export default __webpack_public_path__ + "static/media/img-easy-on-boarding.79df2e93.png";